import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { FeatureToggleConfig } from "../../interfaces/feature-toggle-config.interface";

@Injectable()
export abstract class FeatureTogglesConfigLoaderService<T extends FeatureToggleConfig> {
  public abstract loadFeatureConfig(): Observable<T>;
}
